export default "__VITE_ASSET__BZqXSdLW__"